<template>
  <input type="date" max="9999-12-31" class="form-control" :value="dateValue" @input="doInput($event)">
</template>
<script>
export default {
  name: 'DatetimeInput',
  props: {
    value: {
      type: [Date, String, null],
      default: null,
    },
    setHandler: {
      type: Function,
      default: () => {
      }
    },
  },
  inject: [
    '$moment'
  ],
  computed: {
    dateValue() {
      return this.value ? this.$moment(this.value).format('yyyy-MM-DD') : null;
    }
  },
  methods: {
    doInput(event) {
      if (event.target.value) {
        this.setHandler({value: new Date(event.target.value)});
      } else {
        this.setHandler({value: null})
      }
    }
  }
}
</script>
